import React from 'react';
import { motion } from 'framer-motion';
import CompanyProfileManager from '../../team/CompanyProfileManager';

const ProfileTab = ({ displayUser, isReadOnly }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="space-y-6"
    >
      <CompanyProfileManager
        organizationId={displayUser?.uid || displayUser?.id}
        isOwner={!isReadOnly}
      />
    </motion.div>
  );
};

export default ProfileTab;
